import { toCamelCaseObject } from "@/lib/util";

export class Label {
  /**
   * @param {Number} id
   * @param {String} nameTh
   * @param {String} nameEn
   * @param {String} nameZh
   * @param {Array} packages - Array of package objects
   */
  constructor(id, nameTh, nameEn, nameZh, packages = []) {
    this.id = id;
    this.nameTh = nameTh;
    this.nameEn = nameEn;
    this.nameZh = nameZh;
    this.packages = packages;
  }

  get selectedPackageCount() {
    return this.packages.length;
  }

  /**
   * Create Label instance from API response
   * @param {Object} response
   * @param {Boolean} useFallback - Whether to fallback to Thai name, defaultValue will be '-' if true, '' if false (default: false)
   * @return {Label}
   */
  static createFromResponse(response, useFallback = false) {
    const { id, name, packageIds } = toCamelCaseObject(response);

    // Determine default value based on fallback mode
    const defaultValue = useFallback ? "-" : "";

    // Convert packageIds to packages array with id property
    const packages =
      packageIds && packageIds.length > 0
        ? packageIds.map((pkgId) => ({ id: pkgId }))
        : [];

    const nameTh = (name && name.th && name.th.trim()) || defaultValue;
    const nameEn =
      (name && name.en && name.en.trim()) ||
      (useFallback ? nameTh : defaultValue);
    const nameZh =
      (name && name.zh && name.zh.trim()) ||
      (useFallback ? nameTh : defaultValue);

    return new Label(id, nameTh, nameEn, nameZh, packages);
  }
}
